import React, { FC, useState } from 'react'
import { Dialog } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { DispatchSetAction } from '@sistemiv/s-components/dist/esm/types/types'
import { Button, ModalDialog, SpinnerIcon } from '@sistemiv/s-components'
import { useTranslation } from 'react-i18next'
import { useProjectsStructure } from '../../repositories/project/projects-structure.repository'
import ProjectList from './ProjectsList'

type MoveToModalProps = {
  open: boolean
  loading?: boolean
  setOpen: DispatchSetAction<boolean>
  onCancel?: () => void
  onMove?: (path: string) => void
}

const MoveToModal: FC<MoveToModalProps> = ({ open, loading, setOpen, onCancel, onMove }) => {
  const [value, setValue] = useState('')
  const { t } = useTranslation()
  const { data: projects, isLoading } = useProjectsStructure()

  return (
    <ModalDialog isOpen={open} setOpen={setOpen} className='!max-w-md'>
      <Dialog.Title as='h3' className='leading-6 text-lg flex justify-between'>
        {t('moveTo')}
        <button onClick={() => setOpen(false)}>
          <XMarkIcon className='w-5 h-5 stroke-gray-500' />
        </button>
      </Dialog.Title>
      {isLoading ? (
        <div className='w-full flex justify-center pt-5'>
          <SpinnerIcon className='text-sky-500 h-7 w-7'></SpinnerIcon>
        </div>
      ) : (
        <div>
          <div className='mt-5 overflow-auto max-h-[250px]'>
            {projects && <ProjectList projects={projects} selected={value} setSelected={setValue} />}
          </div>
          <div className='flex items-center justify-end gap-x-3 mt-6'>
            <Button className='hover:bg-gray-100 active:text-blue-500' onClick={() => onCancel?.()}>
              {t('cancel')}
            </Button>
            <Button
              className='text-white bg-blue-500 disabled:bg-slate-200 disabled:text-slate-400'
              onClick={() => onMove?.(value)}
              disabled={!value}
              loading={loading}
            >
              OK
            </Button>
          </div>
        </div>
      )}
    </ModalDialog>
  )
}

export default MoveToModal
